import React from 'react'
import { Stack, Typography } from '@mui/material'

const PageHeader: React.FC = () => {
  return (
    <Stack component="div" justifyContent="center" alignItems="center" my={10}>
      <Typography fontSize="60px" fontWeight="700" fontFamily="MetaProBold">
        CSCS Smart Check
      </Typography>
      <Typography fontSize={22} sx={{ maxWidth: '70%' }} textAlign="center">
        Providing construction and the built environment a quick, easy and
        secure way of ensuring everyone has the right card for the job they do
        on site
      </Typography>
    </Stack>
  )
}

export default PageHeader
